// Copyright (C) 2026 Skylark Drones

import BaseApi from './baseHttpApi'
import { BASE_API_HOST_URL } from '@/constants'

export default class OAuthApi extends BaseApi {
  whitelistURLs = []

  constructor() {
    super('oauth', BASE_API_HOST_URL)
  }
}
